import { render, staticRenderFns } from "./upUserInfo.vue?vue&type=template&id=c2dd32fe&scoped=true&"
import script from "./upUserInfo.vue?vue&type=script&lang=js&"
export * from "./upUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./upUserInfo.vue?vue&type=style&index=0&id=c2dd32fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dd32fe",
  null
  
)

export default component.exports